"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteAssetsServerHttpResponseBuilder = exports.SiteAssetsServerHttpHandlerBuilder = void 0;
var httpHelper_1 = require("./helper/httpHelper");
exports.SiteAssetsServerHttpHandlerBuilder = function (siteAssetsResponseBuilder) {
    var errorMessage = function (status, message) {
        return "server response: status: " + status + ", message: " + message;
    };
    var rejectMessage = function (status, data) {
        return errorMessage(status, data.message);
    };
    var backupErrorMessage = function (rawHttpResponse) {
        return Promise.resolve(errorMessage(rawHttpResponse.status, rawHttpResponse.statusText));
    };
    var build = function (siteAssetsUrl) {
        return {
            requestUrl: siteAssetsUrl,
            requestInit: { headers: {}, method: 'GET' },
            transformResponse: function (httpResponse) {
                return siteAssetsResponseBuilder.build(httpResponse);
            },
            rejectMessage: rejectMessage,
            extractErrorMessage: function (siteAssetsHttpResponse) {
                var rawHttpResponse = siteAssetsHttpResponse.rawHttpResponse;
                if (rawHttpResponse.status == 500) {
                    try {
                        return rawHttpResponse.json()
                            .then(function (siteAssetsServerError) {
                            return rejectMessage(rawHttpResponse.status, siteAssetsServerError);
                        });
                    }
                    catch (err) {
                        return backupErrorMessage(rawHttpResponse);
                    }
                }
                return backupErrorMessage(rawHttpResponse);
            }
        };
    };
    return {
        build: build
    };
};
exports.SiteAssetsServerHttpResponseBuilder = function () {
    var isCdnHit = function (httpResponse) {
        return (httpResponse.headers.get(httpHelper_1.CDN_HIT_HEADER) || 0) > 0;
    };
    var isWixHiveHit = function (httpResponse) {
        return (httpResponse.headers.get(httpHelper_1.WIX_HIVE_HIT_HEADER) || 'MISS') == 'HIT';
    };
    var build = function (httpResponse) {
        var cdnHit = isCdnHit(httpResponse);
        var wixHiveHit = isWixHiveHit(httpResponse);
        return ({
            isCdnHit: cdnHit,
            isWixHiveHit: wixHiveHit,
            rawHttpResponse: httpResponse,
            reportMetrics: function (moduleMetricsReporter) {
                if (cdnHit)
                    moduleMetricsReporter.meter('cdn-hit');
                if (wixHiveHit)
                    moduleMetricsReporter.meter('wix-hive-hit');
            }
        });
    };
    return {
        build: build
    };
};
